import { FC } from "react";
import useBreakPoints from "../../../shared/utils/useBreakPoints";
import { FilterAndSortProps } from "../../types";
import DesktopFilterSort from "../components/Filter/DesktopFilterSort";
import MobileFilterSort from "../components/Filter/MobileFilterSort";

const FilterAndSort: FC<FilterAndSortProps> = ({
  products,
  itemPerPage,
  productsTotalCount,
  offset,
  collectionPageId,
}) => {
  const { isTablet } = useBreakPoints();

  return isTablet ? (
    <MobileFilterSort collectionPageId={collectionPageId} />
  ) : (
    <DesktopFilterSort
      products={products}
      itemPerPage={itemPerPage}
      productsTotalCount={productsTotalCount}
      offset={offset}
      collectionPageId={collectionPageId}
    />
  );
};

export default FilterAndSort;
